// @flow

import React from 'react';
import get from 'lodash/get';
import { Zoom } from '@riseart/common';
import { ArtCarousel } from '@riseart/art';
import { generatePicturePropsForCDN } from 'shared_components/common/artdirection/picture/Picture';
import { artDirection as CONFIG_ART_DIRECTION } from 'Config';
import { ART_DIRECTION_SIZES } from 'shared_models/ArtDirectionSizes';

import {
  artOverlayGalleryCls,
  artOverlayGalleryZoomImgCls,
} from 'shared_components/arts/overlay/Carousel.less';

/**
 * generateZoomProps
 * @param {Object} imgProperties
 * @return {Object}
 */
function generateZoomProps(imgProperties: Object): Object {
  const { type, alt, className, imgProps, lazyload, image, artDirectionKey } = imgProperties;
  const artDirectionSizes = get(ART_DIRECTION_SIZES, type);
  return {
    alt,
    className,
    imgProps,
    lazyload,
    ...generatePicturePropsForCDN({
      image,
      sizesList: artDirectionSizes,
      artDirectionConfig: get(CONFIG_ART_DIRECTION, artDirectionKey),
    }),
  };
}

type Props = {
  masterImage: Object,
  images: Array<Object>,
  media?: Array<Object> | null | void,
  initialSlide?: number,
};

/**
 * ArtOverlayCarousel
 */
export function ArtOverlayCarousel({ images, media, initialSlide = 0 }: Props) {
  return (
    <ArtCarousel
      className={artOverlayGalleryCls}
      initialSlide={initialSlide}
      images={images.map(({ thumbnail, original, zoomed }, k) => {
        return {
          thumbnail,
          original: original.image ? (
            <Zoom
              key={get(original, 'image.key', k)}
              maxSize={{ width: original.image.width, height: original.image.height }}
              smallImage={{
                ...generateZoomProps(original),
                className: artOverlayGalleryZoomImgCls,
              }}
              largeImage={generateZoomProps(zoomed)}
            />
          ) : (
            original
          ),
        };
      })}
      {...(media ? { media } : null)}
      orientation="landscape" // Pass only landscape value instead of (masterImage.width > masterImage.height ? 'landscape' : 'portrait') due to a bug in vertical slider in AntD Carousel in v4
    />
  );
}
